import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CsControlsModule } from '@cbuild/controls';
import { StyleDisplayModule } from '../../directives/style-display/style-display.module';
import { TransferLeadsComponent } from './transfer-leads.component';
import { TransferLeadsService } from './transfer-leads.service';

@NgModule({
  declarations: [TransferLeadsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CsControlsModule,
    StyleDisplayModule
  ],
  providers: [TransferLeadsService],
  exports: [TransferLeadsComponent]
})
export class TransferLeadsModule {}
